import { useEffect, useState, useRef } from 'react'
import api from '../../services/api'
import { Form, Button, Row, Col } from 'react-bootstrap'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import NavBar from '../../components/NavBar/NavBar.js'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'

import ToastAnimated, { showToast } from '../../ui-lib/toast'
import 'react-toastify/dist/ReactToastify.css'

function Notificacoes() {
  const [body, setBody] = useState([])

  function refreshPage(info) {
    window.location.reload(info)
  }
  useEffect(() => {
    ;(async () => {
      api.get('empresas?ativa=1').then((response) => {
        const respost = response.data
        setBody(respost)
      })
    })()
  }, [])

  function Alert(props) {
    return <MuiAlert elevation={3} variant="filled" {...props} />
  }
  function enviar() {
    return showToast({
      type: 'info',
      message: 'Em desenvolvimento',
    })
  }
  return (
    <div>
      <ToastAnimated />
      <NavBar />
      <Container>
        <Row>
          <Col>
            <Container
              component={Paper}
              elevation={8}
              style={{ marginTop: '3%' }}
            >
              <br />

              <Form>
                <Form.Group>
                  <Form.Label>Assunto da notificação (Contrato)</Form.Label>
                  <Form.Control />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Empresa para qual irá enviar</Form.Label>
                  <Form.Control as="select">
                    {body
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((body) => {
                        return <option>{body.name}</option>
                      })}
                  </Form.Control>
                </Form.Group>
                <FormControlLabel
                  control={<Checkbox name="checkedC" />}
                  label="Enviar para todas"
                />
                <Form.Group>
                  <Form.Label>Mensagem</Form.Label>
                  <Form.Control as="textarea" rows={5} />
                </Form.Group>
              </Form>
              <Button variant="success" onClick={enviar} block>
                Enviar
              </Button>
              <br />
            </Container>
          </Col>
          <Col>
            <Container
              component={Paper}
              elevation={8}
              style={{ marginTop: '3%' }}
            >
              <br />

              <Form>
                <Form.Group>
                  <Form.Label>
                    Assunto da notificação (Pacote de horas)
                  </Form.Label>
                  <Form.Control />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Empresa para qual irá enviar</Form.Label>
                  <Form.Control as="select">
                    {body
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((body) => {
                        return <option>{body.name}</option>
                      })}
                  </Form.Control>
                </Form.Group>
                <FormControlLabel
                  control={<Checkbox name="checkedC" />}
                  label="Enviar para todas"
                />
                <Form.Group>
                  <Form.Label>Mensagem</Form.Label>
                  <Form.Control as="textarea" rows={5} />
                </Form.Group>
              </Form>
              <Button variant="success" onClick={enviar} block>
                Enviar
              </Button>
              <br />
            </Container>
          </Col>
          <Col>
            <Container
              component={Paper}
              elevation={8}
              style={{ marginTop: '3%' }}
            >
              <br />

              <Form>
                <Form.Group>
                  <Form.Label>Assunto da notificação (Avulsas)</Form.Label>
                  <Form.Control />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Empresa para qual irá enviar</Form.Label>
                  <Form.Control as="select">
                    {body
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((body) => {
                        return <option>{body.name}</option>
                      })}
                  </Form.Control>
                </Form.Group>
                <FormControlLabel
                  control={<Checkbox name="checkedC" />}
                  label="Enviar para todas"
                />
                <Form.Group>
                  <Form.Label>Mensagem</Form.Label>
                  <Form.Control as="textarea" rows={5} />
                </Form.Group>
              </Form>
              <Button variant="success" onClick={enviar} block>
                Enviar
              </Button>
              <br />
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Notificacoes
